<template>
    <div>
        <div class="table__responsive">
            <table class="table">
                <thead v-if="!loadingStudents  && workProcesses.length">
                    <tr>
                        <th>{{$t('work_processes.table.header.diploma')}}</th>
                        <th>{{$t('work_processes.table.header.work_process')}}</th>
                        <th>{{$t('work_processes.table.header.self')}}</th>
                        <th>{{$t('work_processes.table.header.teacher')}}</th>
                        <th>{{$t('work_processes.table.header.mentor')}}</th>
                        <th>{{$t('work_processes.table.header.coach')}}</th>
                        <th>{{$t('work_processes.table.header.recipient')}}</th>
                        <th>{{$t('work_processes.table.header.other_student')}}</th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-if="loadingStudents" :key="'loading'" class="table--loading">
                        <td colspan="5">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('work_processes.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingStudents && !workProcesses.length" :key="'no-work_processes'" class="table--empty">
                        <td colspan="5">
                            <div class="text-center">{{$t('work_processes.table.no_work_processes')}}</div>
                        </td>
                    </tr>
                    <tr v-for="(work_process, index) in workProcesses" :key="`${work_process.id}_${index}`">
                        <td>Todo: Diploma name</td>
                        <td>{{ work_process.title }}</td>
                        <td class="table__cell--dot"><span class="dot starter"></span></td>
                        <td class="table__cell--dot"><span class="dot gevorderd"></span></td>
                        <td class="table__cell--dot"><span class="dot beroepsbekwaam"></span></td>
                        <td class="table__cell--dot"><span class="dot not-invited"></span></td>
                        <td class="table__cell--dot"><span class="dot pending"></span></td>
                        <td class="table__cell--dot"><span class="dot"></span></td>
                        <td><span @click="navigateToStudent(work_process)" v-tooltip.right="$t('work_processes.table.view')" class="table__icon icons icon-eye"></span></td>
                    </tr>
                    <tr class="table__navigation" v-if="workProcessesMeta && workProcessesMeta.last_page > 1">
                        <td colspan="9">
                            <pagination :meta="workProcessesMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Watch } from 'vue-property-decorator';
    import Pagination from '@/components/tables/Pagination';
    import { GET_WORK_PROCESSES } from '@/store/modules/work-processes';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class EvaluationStudentsTable extends Vue {
        name = 'work-processes-table';
        id = 0;

        mounted() {
            this.id = this.$route.params.id;

            this.$store.dispatch(GET_WORK_PROCESSES, { params: { id: this.id }});
        }

        get workProcessesMeta() {
            return this.$store.state.work_processes.workProcessesMeta;
        }

        get workProcesses() {
            return this.$store.state.work_processes.workProcesses;
        }

        get loadingStudents() {
            return this.$store.state.work_processes.loading;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_WORK_PROCESSES, { params: { id: this.id, page: pageNo }});
        }

        navigateToStudent(work_process) {
            this.$router.push({ name: 'evaluation-student', params: { user_id: this.id, diploma_id: 314547, work_process_id: work_process.work_process_id }});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/work-processes/WorkProcessesTable.vue